import { SettingsGateway } from './SettingsGateway';
import { EmailBackupFrequency } from '@standardnotes/settings';
import { AbstractService } from '@standardnotes/services';
import { SettingName } from '@standardnotes/domain-core';
export class SettingsService extends AbstractService {
    constructor(sessionManager, apiService, internalEventBus) {
        super(internalEventBus);
        this.sessionManager = sessionManager;
        this.apiService = apiService;
        this.internalEventBus = internalEventBus;
        this.frequencyOptionsLabels = {
            [EmailBackupFrequency.Disabled]: 'No email backups',
            [EmailBackupFrequency.Daily]: 'Daily',
            [EmailBackupFrequency.Weekly]: 'Weekly',
        };
    }
    initializeFromDisk() {
        this.provider = new SettingsGateway(this.apiService, this.sessionManager);
    }
    async listSettings() {
        return this.provider.listSettings();
    }
    async getSetting(name, serverPassword) {
        return this.provider.getSetting(name, serverPassword);
    }
    async getSubscriptionSetting(name) {
        return this.provider.getSubscriptionSetting(name);
    }
    async updateSubscriptionSetting(name, payload, sensitive = false) {
        return this.provider.updateSubscriptionSetting(name, payload, sensitive);
    }
    async updateSetting(name, payload, sensitive = false, totpToken) {
        return this.provider.updateSetting(name, payload, sensitive, totpToken);
    }
    async getDoesSensitiveSettingExist(name) {
        return this.provider.getDoesSensitiveSettingExist(name);
    }
    async deleteSetting(name, serverPassword) {
        return this.provider.deleteSetting(name, serverPassword);
    }
    async generateMfaSecret() {
        return this.provider.getMfaSecret();
    }
    async updateMfaSetting(secret, totpToken) {
        return this.provider.updateSetting(SettingName.create(SettingName.NAMES.MfaSecret).getValue(), secret, true, totpToken);
    }
    getEmailBackupFrequencyOptionLabel(frequency) {
        return this.frequencyOptionsLabels[frequency];
    }
    deinit() {
        var _a;
        (_a = this.provider) === null || _a === void 0 ? void 0 : _a.deinit();
        this.provider = undefined;
        this.sessionManager = undefined;
        this.apiService = undefined;
    }
}
